import { Rating } from '@mui/material'
import Flex from 'frontend/commons/Flex'
import { usePackageCard } from 'frontend/contexts/PackageCardContext'
import { adultsQtyMapper } from 'frontend/helpers/julia-mappers'
import capitalizeWords from 'frontend/utils/capitalize-words'
import getFinalPrice from 'frontend/utils/get-final-price'
import totalNightTextSetter from 'frontend/utils/total-night-text'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom/cjs/react-router-dom'

const HotelInfoCard = ({
  hotelInformation,
  packageLink,
  totalNights,
  totalManager,
  providerId,
  packageConfigurationId
}) => {
  const { t } = useTranslation(['layout'])
  const {
    packageData: { currencyCode },
  } = usePackageCard()

  const getAdultsQty = (adultsQty) => {
    const mappedQty = adultsQtyMapper(adultsQty)

    return !mappedQty
      ? '-'
      : `Precio contado viajando ${
          mappedQty === 1 ? '1 persona' : `${mappedQty} personas`
        }`
  }

  return (
    <Flex className="package-card__dynamic-content__wrapper__hotel-list__records__card">
      <Flex
        vertical
        className="package-card__dynamic-content__wrapper__hotel-list__records__card__wrapper"
      >
        <Flex vertical className="package-card__dynamic-content__wrapper__hotel-list__records__card__hotels">
          {hotelInformation.map((item) => (
            <Flex
              vertical
              className="package-card__dynamic-content__wrapper__hotel-list__records__card__info"
            >
              <Flex
                vertical
                className="package-card__dynamic-content__wrapper__hotel-list__records__card__info__title"
              >
                <h5>{capitalizeWords(item.hotel.name)}</h5>
                <Rating
                  readOnly
                  size="small"
                  className="package-card__dynamic-content__wrapper__hotel-list__records__card__info__title__rating"
                  value={item.hotel.category}
                />
              </Flex>
              <Flex
                vertical
                className="package-card__dynamic-content__wrapper__hotel-list__records__card__info__details"
              >
                <strong className="package-card__dynamic-content__wrapper__hotel-list__records__card__info__details__first-line">
                  {[
                    totalNightTextSetter(
                      providerId === 3 ? item.nights : totalNights
                    ),
                    capitalizeWords(item.regime),
                    capitalizeWords(item.roomType),
                  ].map((item) => (
                    <span>{item}</span>
                  ))}
                </strong>
              </Flex>
            </Flex>
          ))}
        </Flex>
        <Flex vertical className="package-card__dynamic-content__wrapper__hotel-list__records__card__price">
          <span className="package__info__card__data__price">
            {getFinalPrice({
              currencyCode,
              total: totalManager.total,
            })}
          </span>
          <span className="package__info__card__data__occupation">
            {getAdultsQty(hotelInformation[0].occupation)}
          </span>
        </Flex>
      </Flex>
      <Link
        className="package-card__dynamic-content__wrapper__hotel-list__records__card__link"
        to={packageLink(hotelInformation, packageConfigurationId)}
      >
        {t('packages.see_detail')}
      </Link>
    </Flex>
  )
}

export default HotelInfoCard
